module.exports = __webpack_public_path__ + "img/boton_segunda_op.1d38b05c.svg";